export function formatNumber(n: number | string): string {
  const num = typeof n === 'string' ? parseInt(n, 10) : n;
  if (num < 10) return '00' + num;
  if (num < 100) return '0' + num;
  return '' + num;
}

export function regexMatch(str: string): boolean {
  const result = str.match('^([0-9]+(:[0-9]+)?(-[0-9]+)?)$');
  return result !== null && result.length > 1;
}

export function setCookie(name: string, value: string, days = 30): void {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${d.toUTCString()}; path=/`;
}

export function getCookie(name: string): string {
  const nameEq = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEq) === 0) return c.substring(nameEq.length, c.length);
  }
  return '';
}

export function isMobileViewport(): boolean {
  const width = window.innerWidth > 0 ? window.innerWidth : screen.width;
  return width <= 768;
}

export function parseVerseParam(vs: string): { start: number; end: number } {
  const parts = vs.split('-');
  const start = parseInt(parts[0], 10);
  const end = parts[1] !== undefined ? parseInt(parts[1], 10) : start;
  return { start, end };
}

export function buildAudioUrl(ch: number | string, vs: number | string, reciterKey?: string): string {
  if (reciterKey) {
    return `https://everyayah.com/data/${reciterKey}/${formatNumber(ch)}${formatNumber(vs)}.mp3`;
  }
  return `https://guidedverses.s3.amazonaws.com/audios/mishary/64bit/${formatNumber(ch)}/${formatNumber(vs)}.mp3`;
}
